import InstallationListTableRow from './InstallationListTableRow';

export default InstallationListTableRow;
